import React, { useState } from "react";
import styles from "./Editing.module.scss";

import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import { messages } from "../Workflow.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";
import { BinauralMonitoringModal } from "./modals/BinauralMonitoring";
import * as appConfig from "appConfig";

export const Editing: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <div className={styles.container}>
      {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
      <SpatialCarousel showBreadcrumbs>
        {[
          <div key={1} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.editingTitle)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.editingDescription) }}></p>
            </ui.Scrollbars>
          </div>,
          <div key={2} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.editingTitle)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.editingDescription2) }}></p>
            </ui.Scrollbars>
          </div>,
          <div key={3} className={styles.carouselItem}>
            <h4 className={styles.subtitle}>{formatMessage(messages.editingTitle2)}</h4>
            <img
              className={styles.image}
              src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/workflow/4.jpg`}
              alt="feature-comparison"
            />
          </div>,
          <div key={4} className={styles.carouselItem}>
            <h4 className={styles.subtitle}>{formatMessage(messages.editingTitle3)}</h4>
            <img className={styles.image} src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/workflow/5.jpg`} />
          </div>,
        ]}
      </SpatialCarousel>
      <BinauralMonitoringModal visible={isModalVisible} onClose={() => setIsModalVisible(false)} />
    </div>
  );
};
